import React from "react";
import { oneOf, object } from "prop-types";
import { flowTypes } from "../../../utils/campaignFlowTypes";
import SubmitInstagram from "./SubmitInstagram";

export default function SubmitOnboard({
  type = flowTypes.INSTAGRAM,
  onboard,
  ...rest
}) {
  switch (type) {
    // Can add e.g. TikTok here in the future.
    case flowTypes.INSTAGRAM:
    default:
      return <SubmitInstagram post={onboard} {...rest} />;
  }
}

SubmitOnboard.propTypes = {
  type: oneOf(Object.values(flowTypes)),
  onboard: object,
};
